const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

// Obtener inventario de insumos con filtros
export const fetchInventarioInsumos = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/inventario-insumos/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al obtener inventario de insumos');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchInventarioInsumos:', error);
    throw error;
  }
};

// Obtener un insumo por ID
export const fetchInsumoById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/inventario-insumos/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener insumo');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchInsumoById:', error);
    throw error;
  }
};

// Registrar entrada de insumos
export const registrarEntradaInsumos = async (data) => {
  try {
    const response = await fetch(`${API_URL}/movimientos-insumos/entrada`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al registrar entrada');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en registrarEntradaInsumos:', error);
    throw error;
  }
};

// Ajustar inventario de insumo
export const ajustarInsumo = async (data) => {
  try {
    const response = await fetch(`${API_URL}/movimientos-insumos/ajustar`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al ajustar inventario');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en ajustarInsumo:', error);
    throw error;
  }
};

// Exportar inventario a Excel
export const exportarInventarioInsumos = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/inventario-insumos/export`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al exportar inventario');
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `inventario-insumos-${new Date().toISOString().split('T')[0]}.xlsx`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  } catch (error) {
    console.error('Error en exportarInventarioInsumos:', error);
    throw error;
  }
};

// Obtener stock de múltiples items por sus IDs
export const fetchStockByIds = async (consumibleIds) => {
  try {
    const response = await fetch(`${API_URL}/inventario-insumos/stock-by-ids`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ consumibleIds }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener stock de items');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchStockByIds:', error);
    throw error;
  }
};
